import React, { ReactElement } from 'react';

import { useSailthru } from '../../data-sources/sailthru-client/useSailthru';
import { Underline } from '../../shared/underline/Underline';

import { EmailCaptureTestIds } from './EmailCaptureTestIds';
import { Form } from './Form/Form';

export function EmailCapture (): ReactElement {
    useSailthru();

    return (
        <div data-testid={EmailCaptureTestIds.SECTION}>
            <h3 className="text-xl font-bold font-gellix" role="heading">GET A DREAMY INBOX</h3>
            <Form />
            <div className="text-xs mb-0 font-regular font-gellix" role="contentinfo">
                Want bonus entries, winner info, impact updates and more? Sign up for our emails! It&apos;s not required and you can opt out at any time. {' '}
                For more information view our {' '}
                <Underline className="align-bottom" animationStyle="underlineRemains" underlineRemainsColor="white">
                    <a href="/pages/privacy" target="_blank" rel="noopener noreferrer" className="font-bold text-white">privacy policy</a>
                </Underline>.
            </div>
        </div>
    );
}
